/**
 * Utility functions for theme management
 */

export const forceLightTheme = () => {
  // Remove dark class from document immediately
  const root = window.document.documentElement;
  root.classList.remove('dark');

  // Set theme to light in localStorage
  localStorage.setItem('theme', 'light');

  // Also remove any other theme-related classes
  root.classList.remove('dark-mode');
  root.classList.remove('dark-theme');
};

export const getStoredTheme = (): 'light' | 'dark' | null => {
  const stored = localStorage.getItem('theme');
  return stored === 'light' || stored === 'dark' ? stored : null;
};

export const setTheme = (theme: 'light' | 'dark') => {
  const root = window.document.documentElement;

  if (theme === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }

  localStorage.setItem('theme', theme);
};
